import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN, BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN_DIRECTION, BOARD_USERS_LISTS_PAGE_DEFAULT_SIZE, EUserCompatLevel } from 'src/app/conf/board-users';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { BoardUsersList } from 'src/app/model/board-user';
import { selectBoardUsersImported, selectBoardUsersImporting } from 'src/app/store/device-boardusers/device-boardusers.selector';
import * as DeviceBoardusersActions from 'src/app/store/device-boardusers/device-boardusers.actions';
import { PaginationParams } from 'src/app/model/api/pagination-params';

@Component({
	templateUrl: './board-users-import-list.dialog.component.html',
})

export class BoardUsersImportListDialogComponent implements OnInit, OnDestroy {
	imported$: Observable<boolean | undefined>;
	importedSub: Subscription;

	importing: boolean;
	importing$: Observable<boolean | undefined>;
	importingSub: Subscription;

	boardUserList: BoardUsersList = new BoardUsersList();
	compatibility: EUserCompatLevel = EUserCompatLevel.Unknown;

	paging: PaginationParams = {
		size: BOARD_USERS_LISTS_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN,
		order: BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN_DIRECTION,
	};

	// Design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data !== undefined && config.data.boardUserList !== undefined && config.data.boardUserList.Compatibility !== undefined) {
			this.boardUserList = config.data.boardUserList;
			this.compatibility = config.data.boardUserList.Compatibility;
			if (config.data.paging) {
				this.paging = config.data.paging;
			}
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		this.imported$ = this.store.select(selectBoardUsersImported);
		this.importing$ = this.store.select(selectBoardUsersImporting);
	}

	subscribeAll(): void {
		this.importedSub = this.imported$?.pipe(filter(imported => !!imported)).subscribe(
			() => {
				this.closeDialog();
			}
		);
		this.importingSub = this.importing$?.subscribe(
			(importing) => {
				this.importing = importing;
			}
		);
	}

	closeDialog(): void {
		this.ref.close();
	}

	ngOnDestroy(): void {
		this.importedSub?.unsubscribe();
		this.importingSub?.unsubscribe();
	}

	unfitToImport(): boolean {
		return this.compatibility === EUserCompatLevel.Unknown || this.compatibility === EUserCompatLevel.Incompatible;
	}

	compatible(): boolean {
		return this.compatibility === EUserCompatLevel.Compatible;
	}

	almostCompat(): boolean {
		return this.compatibility === EUserCompatLevel.FixControlItem || this.compatibility === EUserCompatLevel.Almost;
	}

	incompatible(): boolean {
		return this.compatibility === EUserCompatLevel.Incompatible;
	}

	submit(): void {
		this.store.dispatch(DeviceBoardusersActions.importBoarduserList({ listId: this.boardUserList.Id, paging: this.paging }));
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
